module.exports = __webpack_public_path__ + "static/media/208left.41cc78d6.jpg";